var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid",style:(_vm.cssVars)},_vm._l((_vm.row.modules),function(module,index){return _c('div',{key:index,staticClass:"grid-item"},[_c(_vm.componentForType(module.type),{tag:"component",attrs:{"value":module}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }